import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {CertinomisComponent} from './Certinomis/certinomis.component';
import { CertinomisGuard } from './certinomis.guard';
import {FourOhFourComponent} from './four-oh-four/four-oh-four.component';

const routes: Routes = [
  { path: '', redirectTo: 'certinomis', canActivate: [CertinomisGuard], pathMatch: 'full' },
  { path: 'certinomis', canActivate: [CertinomisGuard], component: CertinomisComponent},
  {path: 'not-found', canActivate: [CertinomisGuard], component: FourOhFourComponent},
  {path: '**', redirectTo: '/not-found'},
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
